const handleFetchEmpJobOffersFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.empJobOffers = action.payload.data;
  state.currentPage = action.payload.current_page;
  state.perPage = action.payload.limit;
  state.totalPages = action.payload.total_pages;
  state.totalJobOffers = action.payload.total_count;
  state.lastUpdated = action.payload.last_updated;
  state.message = action.payload.message;
};

const handleFetchJobOffersFulfilled = (state, action) => {
  state.status = 'succeeded';

  // Extract payload data safely
  const payloadData = action?.payload?.data;
  const jobData = payloadData?.data?.data || [];
  const paginationInfo = payloadData?.data || {};

  if (jobData.length > 0) {
    state.jobOffers = jobData;
    state.currentPage = paginationInfo.current_page || 1;
    state.perPage = paginationInfo.per_page || 10;
    state.totalPages = paginationInfo.last_page || 0;
    state.totalJobOffers = paginationInfo.total || 0;
    state.lastUpdated = payloadData.last_update || null;
    state.message = paginationInfo.message || '';
  } else {
    state.jobOffers = [];
    state.currentPage = 1;
    state.perPage = 10;
    state.totalPages = 0;
    state.totalJobOffers = 0;
    state.lastUpdated = null;
    state.message = 'No job offers found';
  }
};

const handleFetchDuplicateJobOffersFulfilled = (state, action) => {
  state.status = 'succeeded';

  // Extract payload data safely
  // const payloadData = action?.payload?.data;
  const jobData = action?.payload?.data?.data || [];
  // const paginationInfo = payloadData?.data || {};
  if (jobData.length > 0) {
    state.duplicateJobs = jobData;
    state.currentPage = action?.payload?.data.current_page || 1;
    state.perPage = action?.payload?.data.per_page || 10;
    state.totalPages = action?.payload?.data.last_page || 0;
    state.totalJobOffers = action?.payload?.data.total || 0;
    state.lastUpdated = action?.payload?.data.last_update || null;
    state.message = action?.payload?.data.message || '';
  } else {
    state.duplicateJobs = [];
    state.currentPage = 1;
    state.perPage = 10;
    state.totalPages = 0;
    state.totalJobOffers = 0;
    state.lastUpdated = null;
    state.message = 'No job offers found';
  }
};


const handleFetchJobOWorkerListFulfilled = (state, action) => {
  state.status = 'succeeded';
  const payloadData = action?.payload?.data;
  const jobWorkerData = payloadData?.data?.data || [];
  const paginationInfo = payloadData?.data || {};
  if (jobWorkerData.length > 0) {
    state.jobofferWorkerList = jobWorkerData;
    state.jobWorkerCurrentPage = paginationInfo.current_page || 1;
    state.jobWorkerPerPage = paginationInfo.per_page || 10;
    state.jobWorkerTotalPages = paginationInfo.last_page || 0;
    state.totalJobWorkers = paginationInfo.total || 0;
    state.jobWorkerLastUpdated = payloadData.last_updated || null;
  } else {
    state.jobofferWorkerList = [];
    state.jobWorkerCurrentPage = 1;
    state.jobWorkerPerPage = 10;
    state.jobWorkerTotalPages = 0;
    state.totalJobWorkers = 0;
    state.jobWorkerLastUpdated = null;
  }
}

const handleJobOfferDetailFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.jobDetails = action.payload.data;
};

const handleWorkerJobEncriptedIDFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

const handleJobStatusFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.jobStatus = action.payload.data;
};
const handleChangedJobStatusFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.changedJOStatus = action.payload.data;
};
const handleUpdateJobStatusFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.jobOffers = state.jobOffers.map((jo) =>
    jo.id === action.payload.data.id
      ? { ...jo, status: action.payload.data.status }
      : jo
  );
  state.message = action.payload.message;
}
const handleAddJobOfferFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
}
const handleFetchJobDetailFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.jobDetailView = action.payload.data;
  state.message = action.payload.message;
}
const handleCancelSuggestionFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.suggestedWorkers = action.payload.data;
  state.message = action.payload.message;
}
const handleExtendOfferFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
}
const handleAddSuggestWorkerFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
}
const handleFindWorkerFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.workerSuggestedCount = action.payload?.data?.get_total_suggested_count,
  state.workerAppliedCount = action.payload?.data?.get_total_applied_count,
  state.message = action.payload?.message;

  const payloadData = action?.payload?.data;
  const paginationInfo = payloadData || {};
  if (action?.payload?.data?.data?.length > 0) {
    state.suggestWorkers = payloadData.data;
    state.suggestWorkerCurrentPage = paginationInfo.current_page || 1;
    state.suggestWorkerPerPage = paginationInfo.per_page || 10;
    state.suggestWorkerTotalPages = paginationInfo.last_page || 0;
    state.totalSuggestWorker = paginationInfo.total || 0;
    state.suggestWorkerLastUpdated = payloadData.last_updated || null;
  } else {
    state.suggestWorkers = [];
    state.suggestWorkerCurrentPage = 1;
    state.suggestWorkerPerPage = 10;
    state.suggestWorkerTotalPages = 0;
    state.totalSuggestWorker = 0;
    state.suggestWorkerLastUpdated = null;
  }
}
const handleFetchJobActivityFulfilled = (state, action) => {
  state.status = "succeeded";
  state.activityLogList = action.payload.data;
};

export {
  handleFetchEmpJobOffersFulfilled,
  handleFetchJobOffersFulfilled,
  handleJobOfferDetailFulfilled,
  handleFetchJobOWorkerListFulfilled,
  handleJobStatusFulfilled,
  handleChangedJobStatusFulfilled,
  handleUpdateJobStatusFulfilled,
  handleAddJobOfferFulfilled,
  handleFetchJobDetailFulfilled,
  handleCancelSuggestionFulfilled,
  handleExtendOfferFulfilled,
  handleAddSuggestWorkerFulfilled,
  handleFindWorkerFulfilled,
  handleFetchJobActivityFulfilled,
  handleFetchDuplicateJobOffersFulfilled,
  handleWorkerJobEncriptedIDFulfilled
};